"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformGenericConfig = void 0;
const interface_1 = require("../interface");
const gtmId = 'GTM-P5T8FXW';
exports.PlatformGenericConfig = {
    [interface_1.LSEnv.Local]: {
        auth: `njzupDsCSAn7Jwcu6xxJWA`,
        gtmId,
        preview: `env-36`,
    },
    [interface_1.LSEnv.Dev]: {
        auth: `njzupDsCSAn7Jwcu6xxJWA`,
        gtmId,
        preview: `env-36`,
    },
    [interface_1.LSEnv.Uat]: {
        auth: `Exlh4XvdFWF_7dohcWFGVg`,
        gtmId,
        preview: `env-37`,
    },
    [interface_1.LSEnv.Prod]: {
        auth: `wjVcOMcHT_H5fzfLPN1wJQ`,
        gtmId,
        preview: `env-1`,
    },
};
//# sourceMappingURL=platform-generic.js.map